export default function clone<T>(object: T, replacer?: (this: any, key: string, value: any) => any, reviver?: (this: any, key: string, value: any) => any ): T {
    return JSON.parse(JSON.stringify(object, replacer), reviver);
}